
export const CATEGORY_MAP = {
  "Heart Health": [
    "blood pressure", "heart disease risk", "cholesterol management", "cardiac health", "irregular heartbeat count", "heart rate"
  ],
  "Body Function": [
    "stress level", "body mass index", "body shape index", "vascular capacity","digestion","immune system","cardiac workload",
    "heart rate variability","mental stress index",
  ],
  "Physical Health": [
    "facial skin age", "body mass index", "body shape index", "breathing rate","physical health",
  ],
  "Overall Disease Risk": [
    "cardiovascular risk", "hypertriglyceridemia risk", "heart disease risk", "stroke risk",
    "cardiovascular disease risk", "hypercholesteremia risk",
     "hypertension risk", 
  ],
  "Diabetes Risk": [
    "diabetes risk", "prediabetes risk", "type 2 diabetes risk", "blood sugar regulation", "insulin resistance", "glucose tolerance", "a1c levels",
    "pancreatic health", "metabolic syndrome", "blood sugar balance", "sugar metabolism", "insulin sensitivity",
    "type 2 diabetes prevention", "hypoglycemia", "hyperglycemia", "insulin secretion", "glucose metabolism", "pancreatic dysfunction",
    "diabetic neuropathy"
  ]
};


export const parseProducts = (rawData, itemName) => {
  let matchingProducts = [];

  // 1. Filter products by relevant categories from CATEGORY_MAP based on itemName
  const relevantCategories = CATEGORY_MAP[itemName] || [];
  if (relevantCategories.length > 0) {
    relevantCategories.forEach((category) => {
      if (rawData[category]) {
        rawData[category].forEach(product => {
          if (!matchingProducts.some(existingProduct => existingProduct.product_id === product.product_id)) {
            matchingProducts.push(product);
          }
        });
      }
    });
  }

  // 2. If no matching products from categories, check for symptom products
  if (matchingProducts.length === 0 && rawData.symptoms && rawData.symptoms.length > 0) {
    rawData.symptoms.forEach(product => {
      if (!matchingProducts.some(existingProduct => existingProduct.product_id === product.product_id)) {
        matchingProducts.push(product);
      }
    });
  }

  // 3. If no category or symptom products, fallback to all available products
  if (matchingProducts.length === 0) {
    const fallbackCategories = Object.keys(rawData).filter((key) => key !== 'symptoms');
    fallbackCategories.forEach((category) => {
      if (rawData[category]) {
        rawData[category].forEach(product => {
          if (!matchingProducts.some(existingProduct => existingProduct.product_id === product.product_id)) {
            matchingProducts.push(product);
          }
        });
      }
    });
  }

  // 4. Format the products for UI
  return matchingProducts.map((product) => ({
    id: product.product_id || Math.random(),  // Use product ID or generate random ID
    name: product.product_name,
    description: product.product_description,
    restrictions: product.product_restrictions,
    amazonAffiliateLink: product.product_link,
    productImageAddress: product.product_image_address,
    brand: product.product_brand,
    reason: product.reason,
    vitalName: product.vital_name || null,
    vitalValue: product.vital_value || null,
    brandImageAddress: product.brand_image_address,
  }));
};

